import React, { Component } from "react";

class RequiredField extends Component {
  render() {
    return <span className="requiredfield">*</span>;
  }
}

export default RequiredField;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/Common/RequiredField.js